<div id="content">
    <button [hidden] = 'saveButtonAvailable() === false' class = "savebutton" (click) = "saveData()" i18n="@@itemdetails.save">Zapisz</button>
    <button class = "historybutton" (click) = "openHistory()"  i18n="@@itemdetails.history">Historia</button>
  <div id="subcontent">
    <div id = "columnLeft">
      <h1 i18n="@@itemdetails.Information">Informacje:</h1>
      <ul id="menu">
        <li>
          <a class="label" i18n="@@itemdetails.rfidNumber">Numer RFID</a>
          <div class="qrButton" (click)='shorQRCode(FieldsValues[fieldType.RFIDNumber])' [ngStyle]="{'display': isQrTag(FieldsValues[fieldType.RFIDNumber]) ? 'inline-flex' : 'none'}"></div>
          <div class="barButton" (click)='shorQRCode(FieldsValues[fieldType.RFIDNumber])' [ngStyle]="{'display': isBarTag(FieldsValues[fieldType.RFIDNumber]) ? 'inline-flex' : 'none'}"></div>
          <a class="value">{{FieldsValues[fieldType.RFIDNumber]}}</a>
          <hr>
        </li>
        <li>
          <a class="label" i18n="@@itemdetails.inventoryNr">Numer Inwentaryzacyjny</a>
          <a class="value">{{FieldsValues[fieldType.EvidNumber]}}</a>
          <hr>
        </li>
        <br>
        <br>
        <br>
        <li (mouseenter)='editMousePresence(fieldType.Category,true)' (mouseleave)='editMousePresence(fieldType.Category,false)'>
          <a class="label" i18n="@@itemdetails.category">Kategoria</a>
          <a class="value">{{FieldsValues[fieldType.Category]}}</a>
          <img class="imgInfo" [ngStyle]="{'visibility': FieldsEditOptions[fieldType.Category] ? 'visible' : 'hidden'}" src="/assets/pencil.png" height="20px"
            (click)='editField(fieldType.Category, this.FieldsValues[fieldType.Category])'>
          <hr>
        </li>
        <li (mouseenter)='editMousePresence(fieldType.Mark,true)' (mouseleave)='editMousePresence(fieldType.Mark,false)'>
          <a class="label" i18n="@@itemdetails.mark">Marka</a>
          <a class="value">{{FieldsValues[fieldType.Mark]}}</a>
          <img class="imgInfo" [ngStyle]="{'visibility': FieldsEditOptions[fieldType.Mark] ? 'visible' : 'hidden'}" src="/assets/pencil.png" height="20px"
            (click)='editField(fieldType.Mark, this.FieldsValues[fieldType.Mark])'>
          <hr>
        </li>

        <li (mouseenter)='editMousePresence(fieldType.PurchaseDate,true)' (mouseleave)='editMousePresence(fieldType.PurchaseDate,false)'>
          <a class="label" i18n="@@itemdetails.purchasedate">Data Zakupu</a>
          <a class="value">{{FieldsValues[fieldType.PurchaseDate] | date: 'fullDate'}}</a>
          <img class="imgInfo" [ngStyle]="{'visibility': FieldsEditOptions[fieldType.PurchaseDate] ? 'visible' : 'hidden'}" src="/assets/pencil.png" height="20px"
            (click)='editDataField(fieldType.PurchaseDate, this.FieldsValues[fieldType.PurchaseDate].toDateString())'>
          <hr>
        </li>

        <li (mouseenter)='editMousePresence(fieldType.Size,true)' (mouseleave)='editMousePresence(fieldType.Size,false)'>
          <a class="label" i18n="@@itemdetails.size">Rozmiar</a>
          <a class="value">{{FieldsValues[fieldType.Size]}}</a>
          <img class="imgInfo" [ngStyle]="{'visibility': FieldsEditOptions[fieldType.Size] ? 'visible' : 'hidden'}" src="/assets/pencil.png" height="20px"
            (click)='editField(fieldType.Size, this.FieldsValues[fieldType.Size])'>
          <hr>
        </li>

        <li (mouseenter)='editMousePresence(fieldType.Link,true)' (mouseleave)='editMousePresence(fieldType.Link,false)'>
          <a class="label" i18n="@@itemdetails.link">Link</a>
          <a class="value" >{{FieldsValues[fieldType.Link]}}</a>
          <img class="imgInfo" [ngStyle]="{'visibility': FieldsEditOptions[fieldType.Link] ? 'visible' : 'hidden'}" src="/assets/pencil.png" height="20px"
            (click)='editField(fieldType.Link, this.FieldsValues[fieldType.Link])'>
          <hr>
        </li>

        <br>
        <br>
        <br>

        <li (mouseenter)='editMousePresence(fieldType.State,true)' (mouseleave)='editMousePresence(fieldType.State,false)'>
          <a class="label" i18n="@@itemdetails.state">Ilość/Stan</a>
          <a class="value">{{FieldsValues[fieldType.State]}}</a>
          <img class="imgInfo" [ngStyle]="{'visibility': FieldsEditOptions[fieldType.State] ? 'visible' : 'hidden'}" src="/assets/pencil.png" height="20px"
            (click)='editField(fieldType.State, FieldsValues[fieldType.State])'>
          <hr>
        </li>

        <li (mouseenter)='editMousePresence(fieldType.Location,true)' (mouseleave)='editMousePresence(fieldType.Location,false)'>
          <a class="label" i18n="@@itemdetails.location">Lokalizacja</a>
          <a class="value">{{FieldsValues[fieldType.Location]}}</a>
          <img class="imgInfo" [ngStyle]="{'visibility': FieldsEditOptions[fieldType.Location] ? 'visible' : 'hidden'}" src="/assets/pencil.png" height="20px"
            (click)='editLocation(fieldType.Location, FieldsValues[fieldType.Location])'>
          <hr>
        </li>

        <li (mouseenter)='editMousePresence(fieldType.Remarks,true)' (mouseleave)='editMousePresence(fieldType.Remarks,false)'>
          <a class="label" i18n="@@itemdetails.remarks">Uwagi</a>
          <a class="value">{{FieldsValues[fieldType.Remarks]}}</a>
          <img class="imgInfo" [ngStyle]="{'visibility': FieldsEditOptions[fieldType.Remarks] ? 'visible' : 'hidden'}" src="/assets/pencil.png" height="20px"
            (click)='editField(fieldType.Remarks, FieldsValues[fieldType.Remarks])'>
          <hr>
        </li>
        <br>
        <br>
        <div (mouseenter)='editMousePresence(fieldType.LinkedFileds,true)' (mouseleave)='editMousePresence(fieldType.LinkedFileds,false)'>
          <div [ngStyle]="{'display': 'inline-flex','width': '100%','height': '30px'}" >
            <h1 [ngStyle]="{'width': '50%'}" i18n="@@itemdetails.linkedproducts">Produkty powiązane:</h1>

            <div [ngStyle]="{'display': 'inline-flex','float': 'right','margin-top' : '15px','width': '50%'}" >
              <img class ="linkedFields" [ngStyle]="{'visibility': (FieldsEditOptions[fieldType.LinkedFileds] && tags.selectedOptions.selected.length > 0) ?
                   'visible' : 'hidden', 'margin-left' : '70%'}" src="/assets/remove.png"
                   (click) = 'removeLinkedTag(tags.selectedOptions.selected)'>
              <img class ="linkedFields" [ngStyle]="{'visibility': FieldsEditOptions[fieldType.LinkedFileds] ? 'visible' : 'hidden', 'margin-right' : '30px'}" src="/assets/plus.png"
                   (click) = 'editField(fieldType.LinkedFileds, "")'>
            </div>
          </div>
          <a [hidden]='messageLinkedField.length === 0' class="warningMessage">{{messageLinkedField}}</a>
          <mat-selection-list #tags>
            <mat-list-option *ngFor="let tag of this.FieldsValues[fieldType.LinkedFileds]" [value]="tag">
              {{tag}}
            </mat-list-option>
          </mat-selection-list>
        </div>
      </ul>
    </div>

    <div id = "columnRight">
      <div id="photoContainer" (mouseenter)='editMousePresence(fieldType.Photos,true)' (mouseleave)='editMousePresence(fieldType.Photos,false)'>
          <h1 i18n="@@itemdetails.inventoryphoto">Zdjęcia z inwentaryzacji</h1>
          <img class="inventoryPhoto" src={{PhotoUrl}} height="60%">
          <img (click)='leftPhotoClick()' id="leftPhotoArrow" src="/assets/photoArrow.png"  [ngStyle]="{'visibility': FieldsEditOptions[fieldType.Photos] ? 'visible' : 'hidden'}">
          <img (click)='rightPhotoClick()' id="rightPhotoArrow" src="/assets/photoArrow.png" [ngStyle]="{'visibility': FieldsEditOptions[fieldType.Photos] ? 'visible' : 'hidden'}">

          <div class="editLinePhoto" >
            <img [ngStyle]="{'visibility': FieldsEditOptions[fieldType.Photos] ? 'visible' : 'hidden'}" class="editPhotoLeft" src="/assets/remove.png" height="30px" (click) ="fileRemove(false)">
            <label  [ngStyle]="{'visibility': FieldsEditOptions[fieldType.Photos] ? 'visible' : 'hidden'}"  for="file-upload" class="custom-file-upload">
              <i class="fa fa-cloud-upload"></i>
            </label>
            <input id="file-upload" type="file" (change)="fileUpload($event, false)"/>
          </div>
          <br>
          <br>
          <div id="spacer">
          </div>
      </div>

      <div id="descContainer" [hidden]="getType() === 'commercial'">
        <h1 i18n="@@itemdetails.productdesc">Opis produktu</h1>
        <ul id="menu">
          <li>
            <a class="label">{{this.FieldsValues[fieldType.Description]}}</a>
            <hr>
          </li>
        </ul>
        <button (click) = "openHistory()" i18n="@@itemdetails.history">Historia</button>
      </div>

      <div id="commercialContainer" [hidden]="getType() != 'commercial'">
        <div id = "columnLeftNoM" (mouseenter)='editMousePresence(fieldType.Miniature,true)' (mouseleave)='editMousePresence(fieldType.Miniature,false)'>
          <h1 i18n="@@itemdetails.descTitle">Opis:</h1>
            <div class="editLinePhoto" >
              <img [ngStyle]="{'visibility': FieldsEditOptions[fieldType.Miniature] ? 'visible' : 'hidden'}" class="editPhotoLeft" src="/assets/remove.png" height="30px" (click) ="fileRemove(true)">
              <label  [ngStyle]="{'visibility': FieldsEditOptions[fieldType.Miniature] ? 'visible' : 'hidden'}"  for="file-upload2" class="custom-file-upload">
                <i class="fa fa-cloud-upload"></i>
              </label>
              <input class="file-upload" id="file-upload2" type="file" (change)="fileUpload($event, true)"/>

            </div>
          <div class="miniatureContainer">
            <img class="miniature"  src={{CommercialPhoto}} width="70%" >
          </div>
        </div>

        <div id = "columnRightNoM">
          <ul id="menu">
            <li>
              <br>
              <br>
              <br>
              <br>
              <br>
              <div class="editLine" (mouseenter)='editMousePresence(fieldType.Title,true)' (mouseleave)='editMousePresence(fieldType.Title,false)'>
                <a class="labelAllign">{{this.FieldsValues[fieldType.Title]}}</a>
                <img [ngStyle]="{'visibility': FieldsEditOptions[fieldType.Title] ? 'visible' : 'hidden'}" class="editIco" src="/assets/pencil.png" height="20px"
                  (click)='editField(fieldType.Title, this.FieldsValues[fieldType.Title])'>
              </div>
              <hr>
              <br>
              <br>
              <div class="editLine" (mouseenter)='editMousePresence(fieldType.Description,true)' (mouseleave)='editMousePresence(fieldType.Description,false)'>
                <a class="labelAllign">{{this.FieldsValues[fieldType.Description]}}</a>
                <img [ngStyle]="{'visibility': FieldsEditOptions[fieldType.Description] ? 'visible' : 'hidden'}" class="editIco" src="/assets/pencil.png" height="20px"
                  (click)='editField(fieldType.Description, this.FieldsValues[fieldType.Description])'>
              </div>
              <hr>
            </li>
          </ul>
        </div>
    </div>

  </div>
</div>
